module.exports = __webpack_public_path__ + "static/media/unboxing_summer_5.e4e722b5.jpg";